<template>
  <div class="border-white border-2 overflow-hidden shadow-md rounded-xl">
    <p
      class="font-semibold flex justify-start items-center text-gray-800 tracking-widest bg-gradient-to-b from-gray-50 p-2 text-left border-b"
    >
      Opening Hours
      <img class="h-5 ml-1" src="@/assets/icons/clock.svg" />
    </p>
    <div
      class="bg-white text-left space-y-0.5 p-2 rounded-b-xl text-sm overflow-hidden"
    >
      <p v-for="day in days" :key="day" class="flex space-x-2 items-center">
        <span class="font-semibold text-gray-500">{{ day }}: </span
        ><span class="flex-1">{{
          openingHours?.[day.toLowerCase()]
        }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    days() {
      return [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
    },
    openingHours() {
      return this.$store.state.appDetails?.openingHours;
    },
  },
};
</script>
